var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsDashboard = function SvgFormsDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5F6771",
    d: "M28.375 2.5H47.5v13.375H28.375zM2.5 2.5h19.125v24.875H2.5zM28.375 22.625H47.5V47.5H28.375zM2.5 34.125h19.125V47.5H2.5z"
  })));
};
export default SvgFormsDashboard;